module.exports = __webpack_public_path__ + "img/controls.d3ee2068.png";